import APi from 'api'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import useQueryParams from 'utils/hooks/useQueryParams'
import { ROUTES } from 'constants/routes'
import { notificationShow } from 'modules/Notifications/actions'

const VkAdsMarketCode = () => {
  const dispatch = useDispatch()
  const { query: { code } = {} } = useQueryParams()
  const pathGen = useGeneratePathI18n()

  useEffect(() => {
    const api = new APi({
      baseURL: '/api/app/v1',
    })

    api
      .post('/networks/vk/access_token', {
        data: { code },
      })
      .then(({ response, error }) => {
        if (error) {
          throw new Error(error.statusText)
        } else {
          if (!global.opener || typeof global.opener.getBack === 'undefined') {
            global.location.assign(
              pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT_REGISTER, {
                networkType: 'vk',
              }),
            )
            return
          }

          global.opener.getBack(response.data)

          global.close()
        }
      })
      .catch((error) => {
        dispatch(
          notificationShow({
            type: 'error',
            message: 'common::notifications.unexpected_error',
          }),
        )
        console.logXHR(error)
      })
  }, [])

  return null
}

export default VkAdsMarketCode
